(function () {
    'use strict';

    var module = angular.module('uwAgenda.charts');
    module.factory('ChartService', ['$http', 'HelperService', ChartServiceFn]);

    /* service for requesting chart data  */
    function ChartServiceFn($http, HelperService) {
        var baseUrl = '/api/charts/';

        var service = {
            getAppointments: getAppointments,
            getDayTasks: getDayTasks,
            getMessages: getMessages
        };

        return service;

        /* get appointments & online bookings */
        function getAppointments(agendaId, startDate, endDate, onlineBookings, chartView, agendaLabelIds, patientId, confirmedPatients) {
            return $http({
                url: baseUrl + 'appointments/' + agendaId + '/' + onlineBookings + '/' + chartView,
                method: 'GET',
                params: {
                    startDate: HelperService.backendDate(startDate),
                    endDate: HelperService.backendDate(endDate),
                    agendaLabelIds: (agendaLabelIds ? agendaLabelIds : null),
                    patientId: (patientId >= 0 ? patientId : null),
                    confirmedPatients: confirmedPatients
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* get daytasks */
        function getDayTasks(agendaId, startDate, endDate, showFinished, chartView) {
            return $http({
                url: baseUrl + 'daytasks/' + agendaId + '/' + HelperService.backendDate(startDate) + '/' + HelperService.backendDate(endDate) + '/' + (showFinished ? showFinished : false) + '/' + chartView,
                method: 'GET'
            }).then(function (response) {
                return response.data;
            });
        }

        /* get calls & messages */
        function getMessages(agendaId, startDate, endDate, chartView, messageTypes) {
            return $http({
                url: baseUrl + 'messages/' + agendaId + '/' + HelperService.backendDate(startDate) + '/' + HelperService.backendDate(endDate) + '/' + chartView,
                method: 'GET',
                params: {
                    messageTypes: (messageTypes ? messageTypes : null),
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }
})();